import { render, staticRenderFns } from "./TicketTierManager.vue?vue&type=template&id=519901fb&scoped=true"
import script from "./TicketTierManager.vue?vue&type=script&lang=js"
export * from "./TicketTierManager.vue?vue&type=script&lang=js"
import style0 from "./TicketTierManager.vue?vue&type=style&index=0&id=519901fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519901fb",
  null
  
)

export default component.exports